module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select":"select","save":"save","back":"back"},"id":{"select":"pilih","save":"simpan","back":"kembali"},"ms":{"select":"pilih","save":"simpan","back":"kembali"},"zh":{"select":"select","save":"save","back":"back"},"ta":{"select":"select","save":"save","back":"back"}}')
  delete Component.options._Ctor
}
